import React, { useState } from "react";
import { FaSortAmountUp, FaSortAmountDown, FaEllipsisV } from "react-icons/fa";
import { useRef, useEffect } from "react";

const TableauDynamique = ({
  colonnes,
  colonnesdropdown = [],
  donnees,
  isLoading,
  messageAucun = "Aucune donnée trouvée.",
  onSelectRow,
  onAction,
  itemsPerPage = 10,
}) => {
  const [selectedRow, setSelectedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPageState, setItemsPerPageState] = useState(itemsPerPage);
  const [searchTerm, setSearchTerm] = useState("");
  // const [openDropdownId, setOpenDropdownId] = useState(null);

  // État pour gérer le tri
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "ascending" });

  const [openDropdownId, setOpenDropdownId] = useState(null);
  const dropdownRef = useRef(null);

  const toggleDropdown = (id) => {
    setOpenDropdownId((prevId) => (prevId === id ? null : id));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownItemStyle = {
    padding: '8px 12px',
    width: '100%',
    textAlign: 'left',
    border: 'none',
    background: 'none',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  };


  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const handleRowClick = (item) => {
    setSelectedRow(item.id);
    if (onSelectRow) {
      onSelectRow(item);
    }
  };

  const handleAction = (item, actionKey) => {
    if (onAction) {
      onAction(item, actionKey);
    }
  };

  const totalItems = donnees.length;
  const totalPages = Math.ceil(totalItems / itemsPerPageState);
  const indexOfLastItem = currentPage * itemsPerPageState;
  const indexOfFirstItem = indexOfLastItem - itemsPerPageState;

  // Filtrage des données en fonction du terme de recherche
  const donneesFiltrees = donnees.filter((item) =>
    colonnes.some((col) => {
      const value = item[col.cle]?.toString().toLowerCase() || "";
      return value.includes(searchTerm.toLowerCase());
    })
  );

  // Tri des données
  const donneesTriees = [...donneesFiltrees].sort((a, b) => {
    if (sortConfig.key) {
      const valueA = a[sortConfig.key]?.toString().toLowerCase() || "";
      const valueB = b[sortConfig.key]?.toString().toLowerCase() || "";
      if (valueA < valueB) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (valueA > valueB) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
    }
    return 0;
  });

  const donneesAffichees = donneesTriees.slice(indexOfFirstItem, indexOfLastItem);


  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <select
          value={itemsPerPageState}
          onChange={(e) => {
            setItemsPerPageState(Number(e.target.value));
            setCurrentPage(1);
          }}
          className="form-select bg-light p-1"
          style={{ width: "auto", border: "1px black solid", borderRadius: "5px" }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>

        <input
          type="text"
          placeholder="Rechercher..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="form-control"
          style={{ width: "300px" }}
        />
      </div>

      <div className="table-responsive">
        <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
          <thead>
            <tr>
              {colonnes.map((col, index) => (
                <th
                  key={index}
                  className="text-secondary text-wrap d-none d-md-table-cell"
                  onClick={() => handleSort(col.cle)}
                  style={{ cursor: "pointer" }}
                >
                  {col.titre}{" "}
                  {sortConfig.key === col.cle && sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                </th>
              ))}
              <th className="text-secondary text-wrap d-none d-md-table-cell">Actions</th>
            </tr>
          </thead>

          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={colonnes.length} className="text-center">
                  <div className="spinner-border mt-4" role="status">
                    <span className="visually-hidden"></span>
                  </div>
                </td>
              </tr>
            ) : donneesAffichees.length > 0 ? (
              donneesAffichees.map((item) => (
                <tr
                  key={item.id}
                  // onClick={() => handleRowClick(item)}
                  // className={selectedRow === item.id ? "bg-success text-white" : ""}
                  style={{ cursor: "pointer" }}
                >
                  {colonnes.map((col, idx) => (
                    <td key={idx} className="">{item[col.cle]}</td>
                  ))}

                  <td>

                    <button
                      className="btn btn-sm d-flex align-items-center"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleDropdown(item.id);
                        setOpenDropdownId(openDropdownId === item.id ? null : item.id);
                      }}
                      style={{
                        padding: '0.25rem 0.5rem',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        backgroundColor: '#f8f9fa'
                      }}
                    >
                      <FaEllipsisV title="Actions" className="ms-1" size={12} />
                    </button>

                    {openDropdownId === item.id && (
                      <div
                        ref={dropdownRef}
                        style={{
                          position: 'fixed',
                          zIndex: 1000,
                          backgroundColor: 'white',
                          borderRadius: '8px',
                          boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                          padding: '10px',
                          '@media (min-width: 768px)': {
                            // Style pour desktop
                            position: 'absolute',
                            bottom: 'auto',
                            left: 'auto',
                            right: '0',
                            minWidth: '200px'
                          }
                        }}
                        className="custom-scrollbar"
                      >
                        {colonnesdropdown.map((col, idx) => (
                          <button
                            key={idx}
                            style={dropdownItemStyle}
                            onClick={() => {
                              setOpenDropdownId(null);
                              onAction(item, col); // ✅ col contient { label, icon, actionKey }
                            }}
                          >
                            {col.icon && (
                              <span className="mr-2" style={{ marginRight: "8px" }}>
                                {col.icon}
                              </span>
                            )}
                            <span>{col.label || "Action"}</span>
                          </button>
                        ))}
                      </div>
                    )}

                  </td>


                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={colonnes.length} className="text-center text-muted">
                  {messageAucun}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-between align-items-center mt-3">
        <div>
          {donneesFiltrees.length === 0
            ? "Aucun élément à afficher"
            : `Affichage de ${indexOfFirstItem + 1} à ${indexOfLastItem > donneesFiltrees.length ? donneesFiltrees.length : indexOfLastItem} sur ${donneesFiltrees.length}`}
        </div>

        <div className="d-flex align-items-center">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            className={`badge ${currentPage === 1 ? "bg-secondary" : "bg-success"} mx-1`}
            style={{
              border: "1px solid #ccc",
              padding: "8px 12px",
              fontSize: "14px",
              cursor: currentPage > 1 ? "pointer" : "not-allowed",
              opacity: currentPage > 1 ? 1 : 0.6,
              color: "white",
            }}
            disabled={currentPage === 1}
          >
            &laquo;
          </button>

          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index + 1}
              onClick={() => setCurrentPage(index + 1)}
              className={`badge ${currentPage === index + 1 ? "badge-default" : "badge-light text-dark"} mx-1`}
              style={{
                border: "1px solid #ccc",
                padding: "8px 12px",
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              {index + 1}
            </button>
          ))}

          <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            className={`badge ${currentPage === totalPages ? "bg-secondary" : "bg-success"} mx-1`}
            style={{
              border: "1px solid #ccc",
              padding: "8px 12px",
              fontSize: "14px",
              cursor: currentPage < totalPages ? "pointer" : "not-allowed",
              opacity: currentPage < totalPages ? 1 : 0.6,
              color: "white",
            }}
            disabled={currentPage === totalPages}
          >
            &raquo;
          </button>
        </div>
      </div>
    </div>
  );
};

export default TableauDynamique;